<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    allowHtml: {
      type: Boolean,
      default: false
    },
    message: String,
    messageClass: [String, Array, Object],
    boxed: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      validator: (value) => ['danger', 'warning', 'success'].includes(value),
      default: null
    }
  });

  const classes = computed(() => [
    'base-message',
    props.variant ? `base-message--${props.variant}` : null,
    { 'base-message--boxed': props.boxed },
    props.messageClass
  ]);
</script>

<template>
  <div
    v-if="message || $slots.default"
    v-bind="$attrs"
    :class="classes"
    role="alert"
  >
    <slot v-if="$slots.default" />
    <span v-else-if="allowHtml" v-html="message" />
    <template v-else>{{ message }}</template>
  </div>
</template>
